import { useState, useRef, useEffect, useCallback } from 'react';
import {
  ConteinerPaginate,
  DateInfo,
  IdInfo,
  List,
  Loader,
  LoaderConatiner,
  PaginateButtonLeft,
  PaginateButtonRight,
  PaginateNumber,
  PenButton,
  PercentItem,
  Progress,
  ProgressBar,
  StatInformationBlock,
  StatsPageItem,
  StatsPageListConteiner,
  TimeInfo,
  UserImg,
  UserInfoBlock,
  UserName,
} from '../../QaPage/SupportVip/SupportVip.styled';
import testImg from '../../../images/testImg.png';
import SupportMenu from '../../QaPage/SupportMenu/SupportMenu';
import { useDispatch, useSelector } from 'react-redux';
import { getLiveChatAgentThunk } from '../../../redux/qa/qaActions';
import {
  selectAccessToken,
  selectQaChats,
  selectSwitcher,
} from '../../../redux/selectors';
import { DoneIcon, Cross } from '../../QaPage/SupportMenu/SupportMenu.styled';

const Personal_chat_stat = ({
  selectedColor,
  selectedStatus,
  searchId,
  searchThreadId,
  searchUser,
  clickModal,
  isAfterDate,
  isBeforeDate,
  DeleteClick,
  selectedProject,
  selectedGroup,
  searchChecked,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const modalRef = useRef(null);
  const dispatch = useDispatch();
  const [userId, setUserId] = useState(null);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(true);
  
  // Используем пропсы для дат вместо внутренних состояний

  const token = useSelector(selectAccessToken);
  const chats = useSelector(selectQaChats);
  const switcher = useSelector(selectSwitcher);

  const formatTime = time => {
    const [hoursPart, minutesPart, secondsPart] = time.split(':');
    const [seconds, milliseconds] = secondsPart.split('.');

    let hours = parseInt(hoursPart, 10);
    let minutes = parseInt(minutesPart, 10);
    let secondsFloat = parseFloat(`${seconds}.${milliseconds}`);

    if (secondsFloat >= 59.5) {
      minutes += 1;
    }

    if (minutes >= 60) {
      hours += 1;
      minutes = 0;
    }

    const displayHours = hours > 9 ? hours : `0${hours}`;
    const displayMinutes = minutes > 9 ? minutes : `0${minutes}`;

    const timeStr = `${displayHours} час ${displayMinutes} минуты`;

    return timeStr;
  };

  const formatDate = date => {
    const regex = /(\d{4})-(\d{2})-(\d{2})T(\d{2}:\d{2})/;
    const match = date.match(regex);

    if (match) {
      const year = match[1];
      const month = match[2];
      const day = match[3];
      const time = match[4];

      return `${day}/${month}/${year} | ${time}`;
    } else {
      console.log('Неверный формат даты');
    }
  };

  const toggleModal = userId => {
    setOpenModal(prevState => !prevState);
    setUserId(userId);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  const handleClickOutside = event => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setOpenModal(false);
    }
  };

  useEffect(() => {
    if (openModal) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openModal]);

  // Сброс страницы при изменении фильтров (как в SupportVip)
  useEffect(() => {
    setPage(1);
    setShouldFetch(true);
  }, [
    selectedStatus,
    selectedColor,
    clickModal,
    DeleteClick,
    selectedProject,
    selectedGroup,
    // searchUser - игнорируем для личной статистики
    searchId,
    searchThreadId,
    isAfterDate,
    isBeforeDate,
    searchChecked,
  ]);

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      setIsLoading(true);
      console.log(searchChecked);
      try {
        await dispatch(
          getLiveChatAgentThunk({
            token,
            page,
            selectedColor,
            selectedStatus,
            searchId,
            searchThreadId,
            isAfterDate,
            searchUser: null, // Игнорируем фильтр по агенту для личной статистики
            isBeforeDate,
            project: parseInt(selectedProject),
            group: selectedGroup,
            signal: controller.signal,
            checked: searchChecked,
          })
        );
        setShouldFetch(false);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Ошибка запроса:', error);
        }
      }
      setIsLoading(false);
    };

    if (shouldFetch && !clickModal) {
      fetchData();
    }

    return () => {
      controller.abort();
    };
  }, [
    page,
    selectedStatus,
    selectedColor,
    isAfterDate,
    isBeforeDate,
    clickModal,
    selectedProject,
    selectedGroup,
    dispatch,
    shouldFetch,
    // searchUser - игнорируем для личной статистики
    searchId,
    searchThreadId,
    searchChecked,
    token,
  ]);

  const handlePageChange = useCallback(
    newPage => {
      if (!isLoading) {
        setPage(newPage);
        setShouldFetch(true);
      }
    },
    [isLoading]
  );

  return (
    <>
      <StatsPageListConteiner>
        {/* Заголовок страницы */}

        {isLoading ? (
          // Отображаем индикатор загрузки, если идет загрузка данных
          <LoaderConatiner>
            <Loader />
          </LoaderConatiner>
        ) : (
          <List>
            {chats?.results?.map(item => (
              <StatsPageItem
                key={item.thread_id}
                isMultiple={
                  Array.isArray(item.username) && item.username.length > 1
                }
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <UserInfoBlock>
                    {item.photo === null ? (
                      <UserImg src={testImg} />
                    ) : (
                      <UserImg src={item.photo} />
                    )}
                    {item.username === null ? (
                      <UserName switcher={switcher}>Артём Ковальцев</UserName>
                    ) : (
                      <UserName switcher={switcher}>
                        {Array.isArray(item.username)
                          ? item.username.join(', ')
                          : item.username}
                      </UserName>
                    )}
                    <IdInfo>{item.thread_id}</IdInfo>
                    {item?.checked_by && (
                      <div style={{
                        fontSize: '11px',
                        color: switcher ? '#9ca3af' : '#6b7280',
                        marginTop: '4px'
                      }}>
                        Проверено: {item.checked_by}
                      </div>
                    )}
                  </UserInfoBlock>
                  <ProgressBar>
                    <Progress percent={item.score} />
                  </ProgressBar>
                  <PercentItem switcher={switcher}>{item.score}</PercentItem>
                  {item?.checked ? <DoneIcon /> : <Cross />}
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginRight: '20px',
                  }}
                >
                  <StatInformationBlock>
                    <DateInfo>{formatDate(item.created_at)}</DateInfo>
                    <TimeInfo>{formatTime(item.chat_duration)}</TimeInfo>
                  </StatInformationBlock>
                  <PenButton
                    switcher={switcher}
                    onClick={() => toggleModal(item.pk)}
                  />
        </div>
              </StatsPageItem>
            ))}
          </List>
        )}
        <ConteinerPaginate>
          {chats?.previous === null || page === 1 ? null : (
            <PaginateButtonLeft
              onClick={() => handlePageChange(page - 1)}
              disabled={isLoading || page <= 1}
            />
          )}
          <PaginateNumber>
            {chats?.results?.length > 0 ? page : null}
          </PaginateNumber>
          {chats?.next === null ? null : (
            <PaginateButtonRight
              onClick={() => handlePageChange(page + 1)}
              disabled={isLoading}
            />
          )}
        </ConteinerPaginate>
      </StatsPageListConteiner>
      {openModal && (
        <div ref={modalRef}>
          <SupportMenu
            switcher={switcher}
            userId={userId}
            chats={chats?.results}
            onClose={closeModal}
          />
        </div>
      )}
    </>
  );
};

export default Personal_chat_stat;